import {ApiAccountRepository} from '@infra/domain/model/Account/ApiAccountRepository';
import {ApiBalanceRepository} from '@modules/balance/core/infrastructure/repositories/ApiBalanceRepository';
import {RedeemBalance} from '@modules/balance/core/application/RedeemBalance';

import {SetSubscription} from './Subscription/SetSubscription';
import {SkipMonth} from './Subscription/SkipMonth';
import {SetShippingAddress} from './ShippingAddress/SetShippingAddress';
import {ResetPassword} from './ResetPassword/ResetPassword';
import {UpdateEmail} from './UpdateEmail/UpdateEmail';
import {GetPickupPoints} from './PickupPoint/GetPickupPoints';
import {GetBillingAddress} from './BillingAddress/GetBillingAddress';
import {SetBillingAddress} from './BillingAddress/SetBillingAddress';
import {RedeemPromoCode} from './PromoCode/RedeemPromoCode';
import {UpdateNextOrderDate} from './MyLookiero/UpdateNextOrderDate';
import {GetCalendarDates} from './MyLookiero/GetCalendarDates';
import {DeleteAccount} from './DeleteAccount/DeleteAccount';
import {GetRemainingApplicableOrders} from './PromoCode/GetRemainingApplicableOrders';
import {SetUserAddress} from './UserAddress/SetUserAddress';
import {ViewActiveUserAddressByUserId} from './UserAddress/ViewActiveUserAddressByUserId';
import {ViewParcelIncidentByUserId} from './ParcelIncident/ViewParcelIncidentByUserId';

export const AccountApplication = {
  setSubscription: SetSubscription(ApiAccountRepository),
  skipMonth: SkipMonth(ApiAccountRepository),
  resetPassword: ResetPassword(ApiAccountRepository),
  updateEmail: UpdateEmail(ApiAccountRepository),
  setShippingAddress: SetShippingAddress(ApiAccountRepository),
  setUserAddress: SetUserAddress(ApiAccountRepository),
  viewActiveUserAddressByUserId: ViewActiveUserAddressByUserId(ApiAccountRepository),
  viewParcelIncidentByUserId: ViewParcelIncidentByUserId(ApiAccountRepository),
  getPickupPoints: GetPickupPoints(ApiAccountRepository),
  getBillingAddress: GetBillingAddress(ApiAccountRepository),
  setBillingAddress: SetBillingAddress(ApiAccountRepository),
  redeemBalance: RedeemBalance(ApiBalanceRepository),
  redeemPromoCode: RedeemPromoCode(ApiAccountRepository),
  getRemainingApplicableOrders: GetRemainingApplicableOrders(),
  updateNextOrderDate: UpdateNextOrderDate.bind(undefined, ApiAccountRepository),
  getCalendarDates: GetCalendarDates(ApiAccountRepository),
  deleteAccount: DeleteAccount(ApiAccountRepository),
};
